import React, { useEffect } from 'react';
import i18next from 'i18next';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import { getContrastColor } from '@utils';
import * as storage from '@storage'

const useStyles = makeStyles((theme) => ({
    vacation: {
        backgroundColor: `${storage.getVacColor()}`
    },
    absence: {
        backgroundColor: `${storage.getAbsColor()}`
    },
    ul: {
        '& li': {
            display: 'inline-block',
            margin: '0.5px'
        },
        '& li:last-of-type': {
            borderColor: '#7d7d7d !important',
        }
    },
    divColors: {
        padding: '0px 15px',
        border: '1px solid #bfbfbf',
        borderRadius: '5px',
        fontSize: '10px'
    }
}));

function LegendTypeDay(props) {
    const classes = useStyles();

    const vacationTextColor = getContrastColor(storage.getVacColor());
    const absenceTextColor = getContrastColor(storage.getAbsColor());

    useEffect(() => {

    }, []);

    return (
        <>
            <ul className={classes.ul}>
                <li>
                    <div className={`${classes.divColors} ${classes.vacation}`} style={{ color: vacationTextColor }}>{i18next.t('punchApproval:legend.vacation')}</div>
                </li>
                <li>
                    <div className={`${classes.divColors} ${classes.absence}`} style={{ color: absenceTextColor }}> {i18next.t('punchApproval:legend.absence')}</div>
                </li>
            </ul>
        </>
    );
}

export default withNamespaces(['punchApproval', 'buttons'], { wait: true })(LegendTypeDay);